import { ErrorPage, FlinksMaintenanceGate, reportErrorToServer } from '@applyonline/shared'
import { BadCustomerReviewPage } from '@applyonline/shared/components'
import { EFinancingProgram } from '@if/core/types'
import { useEffect, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes, useSearchParams } from 'react-router-dom'
import Apply from '../ApplicationForm/apply'
import ConsignoCallBack from '../ConsignoCallBack'
import ContractWaitingPage from '../Contract/ContractWaitingPage'
import FlinksIncomeValidationPage from '../Flinks/FlinksIncomeValidationPage'
import FlinksStatusPage from '../Flinks/FlinksStatusPage'
import TermsAndConditionsFlinksPage from '../Flinks/TermsAndConditionsFlinksPage'
import GetStart from '../GetStart/GetStart'
import Eligibility from '../GetStart/PreconditionPage'
import ValidateRecaptchaFailedPage from '../ValidateRecaptchaFailedPage/ValidateRecaptchaFailedPage'
import RouteToStatePage from '../ViewCreditApplication/RouteToStagePage'
import CameraPermissionPage from '../Vouched/CameraPermissionPage'
import FailedIdentificationPage from '../Vouched/FailedIdentificationPage'
import PrivacyPolicy from '../Vouched/PrivacyPolicy'

const TopLevelRoutes = (): JSX.Element => {
  const { i18n } = useTranslation()
  const [searchParams] = useSearchParams()
  const lang = searchParams.get('lang')

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang).catch(reportErrorToServer)
    }
  }, [i18n, lang])

  return (
    <Routes>
      <Route path="/" element={<GetStart />} />
      <Route path="" element={<GetStart />} />
      <Route path="eligibility" element={<Eligibility />} />
      <Route path="digital-verification-policy" element={<PrivacyPolicy />} />
      <Route path="apply/:currentstep" element={<Apply />} />
      <Route path="/creditapplication/:id/failedid" element={<FailedIdentificationPage />} />
      <Route path="/creditapplication/:id/cameraPermission" element={<CameraPermissionPage />} />
      <Route path="/creditapplication/:id/flinks/terms" element={<TermsAndConditionsFlinksPage />} />
      <Route
        path="/creditapplication/:id/flinks/validate"
        element={
          <FlinksMaintenanceGate>
            <FlinksIncomeValidationPage />
          </FlinksMaintenanceGate>
        }
      />
      <Route
        path="/creditapplication/:id/flinks/status"
        element={
          <FlinksMaintenanceGate>
            <FlinksStatusPage />
          </FlinksMaintenanceGate>
        }
      />
      <Route
        path="/creditapplication/:id/badreview"
        element={<BadCustomerReviewPage financingProgram={EFinancingProgram.B2c} />}
      />
      <Route path="/creditapplication/:id/consignoCallBack/applicant" element={<ConsignoCallBack />} />
      <Route path="/creditapplication/:id/contract" element={<ContractWaitingPage />} />
      <Route path="/creditapplication/:id/*" element={<RouteToStatePage />} />
      <Route path="/recaptcha-validation-failed/*" element={<ValidateRecaptchaFailedPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  )
}

export default TopLevelRoutes
